import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'agl-top-bg-section',
  templateUrl: './top-bg-section.component.html',
  styleUrls: ['./top-bg-section.component.scss']
})
export class TopBgSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
